import BaseModel from './base_model';
import bcyclePopup from '../templates/popups/bcycle';
import bcycleAvailablePopup from '../templates/popups/bcycle_available';

export default class Bcycle extends BaseModel {
	/**
	 * Represents a Bcycle linked to the server API.
	 * @constructor
	 * @param {integer} id - The id for the Bcycle API wrapper.
	 */
	constructor(id) {
		super();
		this.id = id;
		this.url = W.api_root + 'bcycle' + '/' + id + '.json';
		this.key = 'Bcycle_' + id;
		this.object_type = 'bcycle';
	}

	popupContent() {
		return bcyclePopup(this);
	}

	// Display realtime on popup open
	displayRealtime() {
		const container = document.querySelector('[data-bcycle-realtime=' + this.id + ']');
		// Get realtime data and display it
		this.realtime((data) => {
			container.innerHTML = bcycleAvailablePopup(data);
		});
	}

	realtime(callback) {
		const url = W.api_root + 'bcycle/' + this.id;
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.json();
			})
			.then((response) => {
				callback(response);
			});
	}
}
